import React from 'react';
import TablePayment from 'slickpay/common/TablePayment.component';
import FaqItem from 'slickpay/online/FaqItem.component';

import { useTranslation } from 'providers/GILT.provider';
import { useSalonGilt } from 'providers/SalonBasicInfo.provider';

import CN from './FaqPannel.module.scss';

export const FaqItemDescription = ({ description, children }) => {
  if (!children) {
    return (
      <div>
        <div className={CN.description}>{description}</div>
        {children}
      </div>
    );
  }
  return <div className={CN.description}>{description}</div>;
};

const LINK_REFUND = 'https://help.getslick.com/en/articles/6898854-processing-refunds-via-slickpay';
const LINK_CASHUP = 'https://help.getslick.com/en/articles/6977033-cashing-up-with-slickpay';

const LINK_BANK = 'https://help.getslick.com/en/articles/6860822-viewing-slickpay-payout-reports';

const FaqPannel = () => {
  const { t } = useTranslation();
  const { isSalonWithGDPR } = useSalonGilt();

  const renderFaqItemDescription = ({ description, children }) => {
    if (children) {
      return (
        <div>
          <div className={CN.description}>{description}</div>
          {children}
        </div>
      );
    }
    return <div className={CN.description}>{description}</div>;
  };

  return (
    <div data-bem="FaqPannel" className={CN.component}>
      <div className={CN.title}>{t('slickPay.faqPanel.title')}</div>
      <div className={CN.container} data-bem="FaqPannel__container">
        <FaqItem
          title={t('slickPay.faqPanel.questions.pinTitle')}
          description={renderFaqItemDescription({
            description: t('slickPay.faqPanel.questions.pinDescription'),
          })}
          isOpen
          variant="full"
        />
        <FaqItem
          title={t('slickPay.faqPanel.questions.refundsTitle')}
          description={renderFaqItemDescription({
            description: t('slickPay.faqPanel.questions.refundsDescription'),
          })}
          variant="full"
          link={LINK_REFUND}
        />
        <FaqItem
          title={t('slickPay.faqPanel.questions.cashUpTitle')}
          description={renderFaqItemDescription({
            description: t('slickPay.faqPanel.questions.cashUpDescription'),
          })}
          variant="full"
          link={LINK_CASHUP}
        />
        <FaqItem
          title={t('slickPay.faqPanel.questions.withdrawTitle')}
          description={renderFaqItemDescription({
            description: t('slickPay.faqPanel.questions.withdrawDescription'),
            children: <TablePayment />,
          })}
          variant="full"
        />
        <FaqItem
          title={t('slickPay.faqPanel.questions.appointmentsTitle')}
          description={renderFaqItemDescription({
            description: t('slickPay.faqPanel.questions.appointmentsDescription'),
          })}
          variant="full"
          link={LINK_BANK}
        />
        {isSalonWithGDPR && (
          <FaqItem
            title={t('slickPay.faqPanel.questions.overThePhoneTitle')}
            description={renderFaqItemDescription({
              description: t('slickPay.faqPanel.questions.overThePhoneDescription'),
            })}
            variant="full"
          />
        )}
      </div>
    </div>
  );
};
export default FaqPannel;
